export const useOrg = () => {
    const orgData = useState('orgData');
    
    return {
        org: readonly(orgData),
        orgId: computed(() => orgData.value?.id),
        orgName: computed(() => orgData.value?.name),
        orgLogo: computed(() => orgData.value?.logo_url),
        orgSlug: computed(() => orgData.value?.slug),
        publicPageSlug: computed(() => orgData.value?.public_page_slug),
        publicSiteIsLive: computed(() => orgData.value?.public_site_is_live)
    };
};